import store from 'store2';
class LocalStorageAdapter {
    getValue(key) {
        const value = store.get(`ls.${key}`);
        return value;
    }
    removeValue(key) {
        return store.remove(`ls.${key}`);
    }
}
export { LocalStorageAdapter };
//# sourceMappingURL=local-storage.adapter.js.map